enum VerificationStatus {
  informationRequired = 'information_required',
  failed = 'failed',
  manualReview = 'manual_review',
  verified = 'verified',
  needsIdDocument = 'needs_id_document',
}

export default VerificationStatus;
